module.exports = __webpack_public_path__ + "static/img/index_snapbot_mm.e8f431e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/index_snapbot_mm.png
// module id = G8Am
// module chunks = 1